import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { LocalDateTimeRange } from '../shared';
const NO_HEARING_SEGMENTS_PROVIDED = 'No hearing segments provided';
const HEARING_SEGMENTS_ON_DIFFERENT_DAYS = 'Hearing segments are on different days';
/**
 * A time-range segment of a court hearing.
 */
export class HearingSegment {
    /**
     * @param timeRange The time range representing this segment.
     */
    constructor(timeRange) {
        this.timeRange = timeRange;
    }
    /**
     * Returns whether all provided hearing segments are on the same date.
     */
    static areOnSameDate(hearingSegments) {
        if (hearingSegments.length === 0) {
            throw new Error(NO_HEARING_SEGMENTS_PROVIDED);
        }
        const aDate = hearingSegments[0].timeRange.start.toLocalDate();
        return hearingSegments.every(segment => segment.timeRange.start.toLocalDate().isEqual(aDate) && segment.timeRange.end.toLocalDate().isEqual(aDate));
    }
    /**
     * For a set of hearing segments assumed to be on the same date, returns the date on which all segments are.
     */
    static getSingleHearingDate(hearingSegments) {
        if (hearingSegments.length === 0) {
            throw new Error(NO_HEARING_SEGMENTS_PROVIDED);
        }
        if (!HearingSegment.areOnSameDate(hearingSegments)) {
            throw new Error(HEARING_SEGMENTS_ON_DIFFERENT_DAYS);
        }
        return hearingSegments[0].timeRange.start.toLocalDate();
    }
    /**
     * Returns true if this `HearingSegment` overlaps with the provided `LocalDateTimeRange`.
     */
    overlaps(value) {
        return !(value.end.isBefore(this.timeRange.start) || value.start.isAfter(this.timeRange.end));
    }
    /**
     * Calculates the overall duration of the hearing segments, doesn't do any filtering for overlaps, just sums them
     */
    static calculateHearingSegmentsDuration(hearingSegments) {
        return hearingSegments.reduce((sum, segment) => sum + segment.timeRange.duration.toMillis(), 0) / 1000;
    }
}
__decorate([
    Type(() => LocalDateTimeRange),
    __metadata("design:type", LocalDateTimeRange
    /**
     * @param timeRange The time range representing this segment.
     */
    )
], HearingSegment.prototype, "timeRange", void 0);
